module.exports = __webpack_public_path__ + "fonts/6ukIWyz7.woff";